export default __webpack_public_path__ + "static/media/14_tag_connecting-room.c3fa72f7.svg";